import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingEventEntriesTemplate  {
    _originalTypeClassName = "zERP.BO.AccountingEventEntriesTemplate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingEventEntriesTemplate.translate = translateService;
}
this.Event = new Domain.AccountingEvent();
this.Groups = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.DatePosted = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
DatePosted:any;
Event:any;
FiscalPeriod:any;
Currency:any;
Groups:any;
static setEvent = ($this, value) => {
var oldValue = $this.Event;
$this.Event = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}
static setGroups = ($this, items) => {
                if (items == null) items = [];
                if ($this.Groups == null) $this.Groups = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Groups.length > 0) {
                    Domain.AccountingEventEntriesTemplate.removeGroups($this, $this.Groups[0]);
                }

                Domain.AccountingEventEntriesTemplate.addManyGroups($this, copyItems);
            }
static addManyGroups = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingEventEntriesTemplate.addGroups($this, items[i]);
                }
            }
static addGroups = ($this, item) => {
                if ($this.Groups == null) $this.Groups = [];
                if (item == null || $this.Groups.indexOf(item) > -1) return;
                $this.Groups.push(item);
}
static addRangeGroups = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingEventEntriesTemplate.addGroups($this, item));
            }
static removeGroups = ($this, item) => {
                if ($this == null || $this.Groups == null || $this.Groups.indexOf(item) === -1) return;
                var _index = $this.Groups.indexOf(item);
                $this.Groups.splice(_index, 1);
}
static clearGroups = ($this) => { $this.Groups = null; }

static ValidateData($this: any): any{let allAmounts = Joove.Common.cast($this?.Groups?.linq?.selectMany((g) => g?.Amounts)?.toArray(), "System.Collections.List");
allAmounts = allAmounts?.linq?.where((e) => e?.DoesNotNeedAccount == false)?.toArray();
if (allAmounts?.linq?.any((e) => e?.Account == null)) {throw Error("Please fill all accounts");}
let totalDebit = allAmounts?.linq?.where((e) => e?.IsDebit)?.toArray()?.linq?.sum((e) => e?.Value);
let totalCredit = allAmounts?.linq?.where((e) => !(e?.IsDebit))?.toArray()?.linq?.sum((e) => e?.Value);
if (CLMS.Framework.Number.NotEqual(() => totalDebit, () => totalCredit)) {throw Error("Debit and credit amounts should be equal");}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}